<template>
  <!--
    ConfirmationDialog.vue
    Generic confirmation dialog component with slots for header, body, and actions.
    Used for confirmation prompts throughout the app.
  -->
  <v-dialog persistent :value="value" width="500">
    <v-card :loading="loading">
      <!-- Progress bar slot (optional, can be used by parent) -->
      <template v-slot:progress>
        <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
      </template>
      <v-card-title>
        <!-- Header slot for custom title/content -->
        <slot name="header"></slot>
      </v-card-title>
      <v-card-text>
        <!-- Body slot for main dialog content -->
        <slot name="body"></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- Actions slot for dialog buttons -->
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    /**
     * Controls dialog visibility (v-model)
     */
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * Shows loading state on the card
     */
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * Emit event to close the dialog (not used directly in template, but available for parent)
     */
    closeDialog() {
      this.$emit('closeConfirmationDialog');
    },
  },
};
</script>
